import { trpc } from '../../trpc'

/**
 * What every configuration write leaves stale besides its own list: the status
 * (counts, last change, warnings) and the history. Returned as a function so a
 * screen calls it from its mutations' `onSuccess`, next to invalidating its own
 * list.
 */
export const useConfigurationRefresh = (): (() => void) => {
  const utils = trpc.useUtils()
  return () => {
    void utils.configuration.getStatus.invalidate()
    void utils.configuration.listChanges.invalidate()
  }
}
